import React from 'react';
import { Link } from 'react-router-dom';
import styles from './footer.module.scss';
import { LocationSvg, MailSvg } from 'shared/svg';
import { AppLinks } from 'app/router/consts/app-links.enum';

export const Footer: React.FC = () => {
  return (
    <div className={styles.footer__container}>
      <div className={styles.container__content}>
        <div className={styles.content__info}>
          <div className={styles.info__block}>
            <div className={styles.block__title}>Компания</div>
            <div className={styles.block__content}>
              <div className={styles.content__about_us}>
                BookUp — веб-сервис управления записью и аналитики для
                микробизнеса. Онлайн-запись 24/7, автоматические уведомления в
                VK, ролевой доступ и отчёты.
              </div>
            </div>
          </div>
          <div className={styles.info__block}>
            <div className={styles.block__title}>Информация</div>
            <div className={styles.block__content}>
              <div className={styles.content__business_info}>
                Инн: 212710062014
              </div>
            </div>
          </div>

          <div className={styles.info__block}>
            <div className={styles.block__title}>Правовая информация</div>
            <div className={styles.block__content}>
              <div className={styles.content__legal}>
                <Link
                  to={AppLinks.PrivacyPolicyLink}
                  className={styles.legal__link}
                >
                  Политика конфиденциальности
                </Link>
                <Link
                  to={AppLinks.TermsOfServiceLink}
                  className={styles.legal__link}
                >
                  Пользовательское соглашение
                </Link>
                <Link
                  to={AppLinks.CookiePolicyLink}
                  className={styles.legal__link}
                >
                  Политика cookie
                </Link>
                <Link
                  to={AppLinks.LicenseAgreementLink}
                  className={styles.legal__link}
                >
                  Лицензионный договор
                </Link>
              </div>
            </div>
          </div>

          <div className={styles.info__block}>
            <div className={styles.block__title}>Контакты</div>
            <div className={styles.block__content}>
              <div className={styles.content__contacts}>
                <div className={styles.contacts__block}>
                  <div className={styles.block__svg}>
                    <MailSvg />
                  </div>
                  <div className={styles.block__text}>support@book-up.ru</div>
                </div>
                <div className={styles.contacts__block}>
                  <div className={styles.block__svg}>
                    <LocationSvg />
                  </div>
                  <div className={styles.block__text}>Нижний Новгород</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
